export default {
  GET_INSTRUMENTATION_ALERTS_REQUEST: 'GET_INSTRUMENTATION_ALERTS_REQUEST',
  GET_INSTRUMENTATION_ALERTS_SUCCESS: 'GET_INSTRUMENTATION_ALERTS_SUCCESS',
  GET_INSTRUMENTATION_ALERTS_FAILURE: 'GET_INSTRUMENTATION_ALERTS_FAILURE',

  UPDATE_ALERT_CLOSE_REQUEST: 'UPDATE_ALERT_CLOSE_REQUEST',
  UPDATE_ALERT_CLOSE_SUCCESS: 'UPDATE_ALERT_CLOSE_SUCCESS',
  UPDATE_ALERT_CLOSE_FAILURE: 'UPDATE_ALERT_CLOSE_FAILURE'
};
